import { useSelector } from 'react-redux';
import { thoughtspot } from 'config';
import { initialiseThoughtspot } from 'utils/thoughtspotInit';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getIsReseller } from 'store/publisher/selectors';
import { Store } from 'components/common/types/Store.types';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import {
  filterByCampaignOwner,
  labsReportVisibleActions,
  TABS_STYLES,
  filterByAssetOwner,
  thoughtspotLiveboardStyles,
  hiddenAssetOwnerThoughtspotLiveboardStyles,
} from '../LabsReportDropdown/utils';
import { getUpdateParametersForTimeRange, getUpdateParametersForTimezone } from '../utils';

const DealHealth: React.FC = () => {
  const { localeCode, marketId, timezone, timezoneOverride } = useSelector(
    (state: Store) => state.publisher.configuration,
  );
  const isReseller = useSelector(getIsReseller);

  initialiseThoughtspot(localeCode, cancelFunctions);

  const dealHealthLiveboardId = isReseller
    ? thoughtspot.resellerDealHealthDashboardId
    : thoughtspot.dealHealthDashboardId;

  const today = new Date();
  const liveboardUpdateParameters = [
    ...getUpdateParametersForTimezone(timezoneOverride ?? timezone),
    ...getUpdateParametersForTimeRange({ startDate: today, endDate: today }),
  ];

  return (
    <div className={TABS_STYLES}>
      <LiveboardVisuals
        liveboardId={dealHealthLiveboardId}
        customizations={isReseller ? thoughtspotLiveboardStyles : hiddenAssetOwnerThoughtspotLiveboardStyles}
        visibleActions={labsReportVisibleActions}
        filterByOptions={[isReseller ? filterByCampaignOwner(marketId) : filterByAssetOwner(marketId)]}
        updateLiveboardParameters={liveboardUpdateParameters}
      />
    </div>
  );
};

export default DealHealth;
